import AlertBox from 'components/storefront/alert-box.vue'

export default {
  components: {
    AlertBox
  },
  data() {
    return {
      alerts: []
    }
  },
  methods: {
    alert(message, type = 'warning') {
      this.alerts.push({
        message,
        type
      })
    }
  }
}
